import { render } from "./ChatItemModel.vue?vue&type=template&id=46580edc&scoped=true"
import script from "./ChatItemModel.vue?vue&type=script&lang=js"
export * from "./ChatItemModel.vue?vue&type=script&lang=js"

import "./ChatItemModel.vue?vue&type=style&index=0&id=46580edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46580edc"]])

export default __exports__